import { useParams, Link } from 'react-router-dom';
import '../../css/SamplePage.css';

function SamplePage() {
    const { title } = useParams();


    // サービスごとのテーマカラー設定
    const serviceColors = {
        広告代理店: {
            primary: '#ec4899', // pink-500
            light: '#f472b6',   // pink-400
            bg: '#ec4899'       // pink-500
        },
        ウェルケア事業部: {
            primary: '#10b981', // green-500
            light: '#34d399',   // green-400
            bg: '#10b981'       // green-500
        },
        イベント企画運営: {
            primary: '#8b5cf6', // purple-500
            light: '#a78bfa',   // purple-400
            bg: '#8b5cf6'       // purple-500
        },
        セールスプロモーション: {
            primary: '#f97316', // orange-500
            light: '#fb923c',   // orange-400
            bg: '#f97316'       // orange-500
        },
        ダイレクトマーケティング: {
            primary: '#3b82f6', // blue-500
            light: '#60a5fa',   // blue-400
            bg: '#3b82f6'       // blue-500
        }
    };

    const currentColor = serviceColors[title] || serviceColors['広告代理店'];

    // サービスごとのサブタイトル設定
    const serviceSubtitles = {
        広告代理店: '広告を通じて企業と人をつなぎ、価値ある出会いを創出',
        ウェルケア事業部: '介護・福祉業界の課題解決と質の高いサービス提供を支援',
        イベント企画運営: '感動的な体験を創造し、心に残る価値を提供',
        セールスプロモーション: 'ブランド価値を向上させ、売上拡大を支援',
        ダイレクトマーケティング: 'データドリブンなアプローチで顧客との絆を深化'
    };

    const currentSubtitle = serviceSubtitles[title] || serviceSubtitles['広告代理店'];

    // サービスごとのマーキーテキスト設定
    const serviceMarqueeTexts = {
        広告代理店: 'ADVERTISEMENT SERVICE',
        ウェルケア事業部: 'WELLCARE SERVICE',
        イベント企画運営: 'EVENT SERVICE',
        セールスプロモーション: 'PROMOTION SERVICE',
        ダイレクトマーケティング: 'MARKETING SERVICE'
    };

    const currentMarqueeText = serviceMarqueeTexts[title] || serviceMarqueeTexts['広告代理店'];

    // マーキーテキストの繰り返し回数を文字数に応じて調整
    const getMarqueeRepeatCount = (text) => {
        const baseLength = 20; // 基準となる文字数
        const textLength = text.length;
        return Math.max(8, Math.ceil(baseLength * 10 / textLength)); // 最小8回、文字数に反比例
    };

    const marqueeRepeatCount = getMarqueeRepeatCount(currentMarqueeText);

    function SectionContent({ content }) {
        return <div dangerouslySetInnerHTML={{ __html: content }} />;
    }

    const pageContent = {
        広告代理店: {
            概要: `<span class="text-2xl md:text-3xl font-bold text-pink-500">最適な広告戦略を企画し、デジタル・アナログを融合させた効果的なプロモーションを提供します。</span><br /> <br /> 
私たちは、マーケットリサーチからターゲット層の詳細な分析を行い、それに基づいた具体的で実現可能なプロモーションプランを立案します。<br /> 
広告の制作から運用、効果検証までの一貫したサービスを提供することで透明性の高いプロセスを保証します。<br />
広告効果を最大化し、クライアントのブランド価値とビジネス成長を持続的に高めるため戦略とクリエイティブの両軸から、本質的な課題解決に導きます。` ,
            特徴: `ターゲット層に合わせた柔軟な戦略設計が特徴です。<br />
- データドリブンなマーケティング<br />
- カスタマイズ可能なアプローチ<br />
- マルチチャネル戦略<br />`,
            事例: `
新商品キャンペーン<br />
- 広告表示数 500万件突破 / 購入率100%向上<br />
地域密着型<br />
- イベント参加者増加 / 満足度評価4.8<br />
デジタル広告効率化<br />
- フォロワー30%増 / 認知度2倍<br />`,
            契約の流れ: `
<ul>
  <li>お問い合わせ・初回相談</li>
  <li>ヒアリングと課題抽出　</li>
  <li>提案・見積もり提示　　</li>
  <li>契約締結　　　　　　　</li>
  <li>企画実行・素材制作　　</li>
  <li>広告運用・改善　　　　</li>
</ul>`
        },
        ウェルケア事業部: {
            概要: `<span class="text-2xl md:text-3xl font-bold text-green-500">介護・福祉業界に特化したサービスを提供し、施設運営の質向上と効率化を支援します。</span><br /> <br /> 
埼玉県で障がい者向けグループホームの運営を行なっております。<br /> 
移動支援や訪問看護ステーションの運営も2026年度中に開業予定になります。<br /> 
適正な支援を必要とする方へワンストップでサービス提供できるように努めます。`,
            特徴: `介護・福祉施設の本質的な課題を見つけ出し、実行可能な解決策を提供します。<br />
- 施設運営支援・業務効率化<br />
- 人材育成・研修プログラム<br />
- 利用者満足度向上施策<br />`,
            事例: `
施設運営効率化プロジェクト<br />
- 業務時間30%削減 / 職員満足度向上<br />
人材育成研修プログラム<br />
- 研修受講率100% / スキル向上効果95%<br />
利用者満足度向上施策<br />
- 満足度20%向上 / サービス品質改善<br />`,
            契約の流れ: `
<ul>
  <li>施設見学・現状ヒアリング</li>
  <li>課題の特定・分析</li>
  <li>改善プランの提案</li>
  <li>契約締結・支援開始</li>
  <li>実行支援・進捗管理</li>
  <li>効果測定・継続改善</li>
</ul>`
        },
        イベント企画運営: {
            概要: `<span class="text-2xl md:text-3xl font-bold text-purple-500">感動と価値を創造する総合的なイベント企画・運営サービスを提供します。</span><br /> <br /> 
イベントを開催したことのない企業の要件定義からお手伝いするなど、<br /> 
規模や形態を問わず豊富な経験とノウハウを持ち、<br />
プライバシーマーク取得による情報管理の中、<br />
ご要望に応じて最適な進め方が可能です。`,
            特徴: `参加者の心に残る、質の高いイベント体験を創造します。<br />
- 企画立案から運営まで一貫サポート<br />
- 多様な形態・規模のイベントに対応<br />
- 最新技術を活用した演出<br />`,
            事例: `
大型展示会運営<br />
- 来場者数5,000名 / 満足度95%達成<br />
企業セミナー企画<br />
- 参加者アンケート評価4.8/5.0 / リピート率80%<br />
プロダクトローンチイベント<br />
- メディア露出20社 / SNS拡散10万リーチ<br />`,
            契約の流れ: `
<ul>
  <li>企画相談・ヒアリング</li>
  <li>コンセプト策定・企画書作成</li>
  <li>詳細企画・予算調整</li>
  <li>契約締結・制作開始</li>
  <li>リハーサル・最終調整</li>
  <li>イベント実施・事後フォロー</li>
</ul>`
        },
        セールスプロモーション: {
            概要: `<span class="text-2xl md:text-3xl font-bold text-orange-500">商品・サービスの魅力を最大限に引き出すセールスプロモーション戦略を展開します。</span><br /> <br /> 
ブランディングから販促ツール制作、キャンペーン実施まで、売上向上に直結するプロモーション活動を総合的にサポートします。<br /> 
市場分析とターゲット設定を基に、効果的なプロモーション戦略を立案し、確実な成果をお届けします。<br />
お客様の商品・サービスの価値を正しく伝え、売上拡大と顧客満足度向上を同時に実現します。`,
            特徴: `売上向上に直結する戦略的なプロモーション活動を展開します。<br />
- ブランディング・コンセプト設計<br />
- 販促ツール・キャンペーン企画<br />
- 効果測定・改善提案<br />`,
            事例: `
新商品プロモーション<br />
- 売上目標120%達成 / 認知度50%向上<br />
店舗販促キャンペーン<br />
- 来店数30%増加 / 客単価15%向上<br />
ブランドリニューアル<br />
- ブランド認知度2倍 / 顧客満足度向上<br />`,
            契約の流れ: `
<ul>
  <li>市場分析・ターゲット設定</li>
  <li>プロモーション戦略立案</li>
  <li>企画詳細・制作計画策定</li>
  <li>契約締結・制作開始</li>
  <li>キャンペーン実施・運用</li>
  <li>効果測定・レポート提出</li>
</ul>`
        },
        ダイレクトマーケティング: {
            概要: `<span class="text-2xl md:text-3xl font-bold text-blue-500">顧客との直接的なコミュニケーションを通じて、高い成果を実現するマーケティング戦略を提供します。</span><br /> <br /> 
あらゆるターゲティングチャネルとデータベースを活用し、<br /> 
潜在層の中から見込客を発見し効果的に獲得するプログラムをご提供します。<br /> 
コール業務から訪問干渉までワンストップでサービス提供可能です。`,
            特徴: `データドリブンなアプローチで確実な成果を追求します。<br />
- 精密なデータ分析・ターゲティング<br />
- マルチチャネル統合戦略<br />
- CRM・MA活用による自動化<br />`,
            事例: `
メールマーケティング強化<br />
- 開封率40%向上 / CVR 3倍達成<br />
顧客セグメント最適化<br />
- ROI 200%改善 / LTV 50%向上<br />
リターゲティング施策<br />
- コンバージョン率25%向上 / CPA 30%削減<br />`,
            契約の流れ: `
<ul>
  <li>データ分析・顧客セグメント調査</li>
  <li>ターゲティング戦略策定</li>
  <li>施策企画・ツール選定</li>
  <li>契約締結・環境構築</li>
  <li>キャンペーン実施・最適化</li>
  <li>効果分析・改善提案</li>
</ul>`
        }
    };
    
    // サービスごとの特徴・強み設定
    const serviceFeatures = {
        広告代理店: [
            {
                title: 'データドリブンなマーケティング',
                desc: 'データに基づいて戦略を立案し、無駄のない最適な施策を展開します。',
                image: '/image/marketing2.png',
            },
            {
                title: 'カスタマイズ可能なアプローチ',
                desc: 'クライアントの課題に合わせて柔軟に施策を設計・実行します。',
                image: '/image/customize.png',
            },
            {
                title: 'マルチチャネル戦略',
                desc: 'オンラインとオフラインのチャネルを統合し、最大の効果を引き出します。',
                image: '/image/chanel.png',
            },
        ],
        ウェルケア事業部: [
            {
                title: '食事提供',
                desc: '朝食・夕食ともに手作りにて提供し、弁当のように冷めていることはありません。',
                image: '/image/cook.png',
            },
            {
                title: 'Wi-Fi完備',
                desc: '全棟Wi-Fi完備',
                image: '/image/wifi.png',
            },
            {
                title: '利用者満足度',
                desc: '全棟全室６畳以上　女性棟・男性棟　完備',
                image: '/image/room.png',
            },
        ],
        イベント企画運営: [
            {
                title: '企画力',
                desc: '参加者の心に残る印象的なイベントを企画・提案します。',
                image: '/image/management.png',
            },
            {
                title: '運営力',
                desc: '当日の円滑な運営で参加者満足度を最大化します。',
                image: '/image/plan.png',
            },
            {
                title: '技術力',
                desc: '最新技術を活用した演出で差別化されたイベントを実現します。',
                image: '/image/tech.png',
            },
        ],
        セールスプロモーション: [
            {
                title: 'ブランディング',
                desc: 'ブランド価値を最大化する戦略的なプロモーションを展開します。',
                image: '/image/marketing.png',
            },
            {
                title: '販促企画',
                desc: '売上向上に直結する効果的な販促ツールを企画・制作します。',
                image: '/image/criant.png',
            },
            {
                title: '効果測定',
                desc: 'データに基づく効果測定で継続的な改善を実現します。',
                image: '/image/strategy.png',
            },
        ],
        ダイレクトマーケティング: [
            {
                title: 'データ分析',
                desc: '精密なデータ分析で最適なターゲティングを実現します。',
                image: '/image/chanel2.png',
            },
            {
                title: 'チャネル統合',
                desc: '複数チャネルを効果的に組み合わせてROIを最大化します。',
                image: '/image/data.png',
            },
            {
                title: '自動化',
                desc: 'CRM・MAツールを活用した効率的なマーケティングを提供します。',
                image: '/image/free.png',
            },
        ],
    };

    // サービスごとの過去事例設定
    const serviceCases = {
        広告代理店: [
            {
                title: '新商品キャンペーン',
                result: '広告表示数 500万件突破 / 購入率100%向上',
            },
            {
                title: '地域密着型プロモーション',
                result: 'イベント参加者増加 / 満足度評価4.8',
            },
            {
                title: 'デジタル広告効率化',
                result: 'フォロワー30%増 / 認知度2倍',
            },
        ],
        ウェルケア事業部: [
            {
                title: '施設運営効率化プロジェクト',
                result: '業務時間30%削減 / 職員満足度向上',
            },
            {
                title: '人材育成研修プログラム',
                result: '研修受講率100% / スキル向上効果95%',
            },
            {
                title: '利用者満足度向上施策',
                result: '満足度20%向上 / サービス品質改善',
            },
        ],
        イベント企画運営: [
            {
                title: '自治体でのスマホ教室',
                result: '',
            },
            {
                title: 'クライアント実店舗周年イベント',
                result: '',
            },
        ],
        セールスプロモーション: [
            {
                title: '新商品プロモーション',
                result: '売上目標120%達成 / 認知度50%向上',
            },
            {
                title: '店舗販促キャンペーン',
                result: '来店数30%増加 / 客単価15%向上',
            },
            {
                title: 'ブランドリニューアル',
                result: 'ブランド認知度2倍 / 顧客満足度向上',
            },
        ],
        ダイレクトマーケティング: [
            {
                title: 'キャッシュレス決済促進',
                result: '',
            },
            {
                title: '飲食店むけデリバリーサービスの導入促進',
                result: '',
            },
            {
                title: 'BtoBでの通信機器販売促進',
                result: '',
            },
        ],
    };

    const currentFeatures = serviceFeatures[title] || serviceFeatures['広告代理店'];
    const currentCases = serviceCases[title] || serviceCases['広告代理店'];

    return (
        <div className="min-h-screen bg-white relative ">
            <header className="fixed top-0 w-full z-50 bg-white shadow-md py-4 px-6 lg:px-12 flex justify-between items-center">
                <Link to="/">
                    <img src="../image/Chaln_black.png" alt="Logo" className="h-12 cursor-pointer" />
                </Link>
                <nav className="hidden lg:flex space-x-6 text-sm font-bold text-black">
                    <Link to="/service/セールスプロモーション" className="hover:text-orange-500 transition">セールスプロモーション</Link>
                    <Link to="/service/広告代理店" className="hover:text-pink-500 transition">広告代理店</Link>
                    <Link to="/service/イベント企画運営" className="hover:text-purple-500 transition">イベント企画運営</Link>
                    <Link to="/service/ダイレクトマーケティング" className="hover:text-blue-500 transition">ダイレクトマーケティング</Link>
                    <Link to="/service/ウェルケア事業部" className="hover:text-green-500 transition">ウェルケア事業部</Link>
                </nav>
            </header>

            <div className="w-full py-36 px-6 lg:px-20" style={{ backgroundColor: currentColor.bg }}>
                <h1 className="text-5xl tracking-wide text-white  text-left font-bold">
                    {title}</h1>
                <p className="mt-4 text-white text-lg lg:text-xl font-light  text-left">
                    {currentSubtitle}
                </p>
            </div>
            <div className="overflow-hidden w-full" style={{ backgroundColor: currentColor.bg }}>
                <div className="flex w-max animate-marquee">
                    {[...Array(2)].map((_, i) => (
                        <span key={i} className="flex gap-16 text-white text-2xl lg:text-9xl font-extrabold pr-16">
                            {Array.from({ length: marqueeRepeatCount }).map((_, j) => (
                                <span key={j}>{currentMarqueeText}</span>
                            ))}
                        </span>
                    ))}
                </div>
            </div>
            <main className="px-6 lg:px-20 space-y-24 pt-52">

                {/* 画像 + 概要 */}
                <section id="overview" className="scroll-mt-36">
                    <div className="flex flex-col lg:flex-row items-start gap-16 px-6 lg:px-20 py-32 relative overflow-hidden">
                        {/* 左側：テキスト */}
                        <div className="lg:w-1/2 space-y-10 text-gray-800 relative z-10">
                            <span className="absolute -left-8 lg:-left-20 -top-16 text-9xl lg:text-[14rem] font-extrabold opacity-20 select-none pointer-events-none leading-none" style={{ color: currentColor.light }}>
                                01
                            </span>
                            <h2 className="text-2xl lg:text-5xl font-bold text-gray-900 tracking-wide relative inline-block">
                                サービス概要
                            </h2>
                            <div className="text-md lg:text-2xl leading-loose tracking-wide text-gray-700">
                                <SectionContent content={pageContent[title].概要} />
                            </div>
                        </div>
                        {/* 右側：画像 */}
                        <div className="lg:w-1/2 flex justify-center items-center">
                            <img
                                src={(() => {
                                    const serviceImages = {
                                        '広告代理店': '/image/広告代理.png',
                                        'ウェルケア事業部': '/image/ウェルケア.png',
                                        'イベント企画運営': '/image/イベント企画.png',
                                        'セールスプロモーション': '/image/advertisement.png',
                                        'ダイレクトマーケティング': '/image/ダイレクトマーケティング.png'
                                    };
                                    return serviceImages[title] || serviceImages['広告代理店'];
                                })()}
                                alt="サービス概要イメージ"
                            />
                        </div>
                    </div>
                </section>

                {/* 特徴 */}
                <section id="features" className="scroll-mt-36">
                    <div className="max-w-8xl mx-auto px-6 lg:px-20 py-32 relative overflow-hidden">
                        <span className="absolute -left-2 top-6 text-9xl lg:text-[14rem] font-extrabold opacity-20 select-none pointer-events-none leading-none" style={{ color: currentColor.light }}>
                            02
                        </span>
                        <h2 className="text-3xl lg:text-5xl font-bold font-zen mb-24 relative inline-block">
                            特徴・強み
                        </h2>
                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                            {currentFeatures.map((feature, index) => (
                                <div key={index} className="zen-2xl p-6 text-center">
                                    <img
                                        src={feature.image}
                                        alt={feature.title}
                                        className="mx-auto h-[8rem] lg:h-[20rem] mb-4"
                                    />
                                    <h3 className="font-bold text-lg lg:text-2xl mb-2">{feature.title}</h3>
                                    <p className="text-sm lg:text-xl text-gray-700">{feature.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* 過去事例 */}
                <section id="features" className="scroll-mt-36">
                    <div className="max-w-8xl mx-auto px-6 lg:px-20 py-32 relative overflow-hidden">
                        <span className="absolute -left-2 top-6 text-9xl lg:text-[14rem] font-extrabold opacity-20 select-none pointer-events-none leading-none" style={{ color: currentColor.light }}>
                            03
                        </span>
                        <h2 className="text-3xl lg:text-5xl font-bold font-zen mb-24 relative inline-block">
                            過去事例
                        </h2>
                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                            {currentCases.map((item, index) => (
                                <div key={index} className="bg-green-50 rounded-2xl p-6 shadow-md hover:scale-105 transition text-center">
                                    <img
                                        src='/image/テスト.png'
                                        alt="過去事例"
                                        className="mx-auto h-24 mb-4"
                                    />
                                    <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                                    <p className="text-sm text-gray-700">{item.result}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* 契約の流れ */}
                <section id="features" className="scroll-mt-36">
                    <div className="max-w-8xl mx-auto px-6 lg:px-20 py-32 relative overflow-hidden">
                        <span className="absolute -left-2 top-6 text-9xl lg:text-[14rem] font-extrabold opacity-20 select-none pointer-events-none leading-none" style={{ color: currentColor.light }}>
                            04
                        </span>
                        <h2 className="text-3xl lg:text-5xl font-bold font-zen mb-24 relative inline-block">
                            契約の流れ
                        </h2>
                        <div className="flex flex-col items-start space-y-12 mx-auto w-fit px-4">
                            {(() => {
                                // ウェルケア事業部の場合は3工程、その他は6工程
                                const steps = title === 'ウェルケア事業部' ? [
                                    { title: 'お問い合わせ・ご相談', desc: 'まずはお気軽にお問い合わせください。' },
                                    { title: '見学・体験入居', desc: '見学や、実際に体験入居も可能です。' },
                                    { title: '契約・本入居', desc: 'ご納得いただいた上でご契約となります。' },
                                ] : [
                                    { title: 'お問い合わせ・初回相談', desc: 'まずはお気軽にご相談ください。' },
                                    { title: 'ヒアリングと課題抽出', desc: 'ご要望や現状の課題を丁寧にヒアリング。' },
                                    { title: '提案・見積もり提示', desc: '最適なプランとお見積もりを提示します。' },
                                    { title: '契約締結', desc: 'ご納得いただいた上でご契約を行います。' },
                                    { title: '企画実行・素材制作', desc: 'プロジェクトを本格的に開始します。' },
                                    { title: '広告運用・改善', desc: '効果測定を行いながら運用を最適化します。' },
                                ];
                                
                                return steps.map((step, index, arr) => (
                                    <div key={index} className="flex items-start">
                                        <div className="w-20 flex flex-col items-center flex-shrink-0">
                                            <div className="w-16 h-16 text-white rounded-full flex items-center justify-center text-2xl font-bold" style={{ backgroundColor: currentColor.primary }}>
                                                {index + 1}
                                            </div>
                                            {index < arr.length - 1 && (
                                                <div className="h-12 border-l-2 border-dashed mt-2" style={{ borderColor: currentColor.light }}></div>
                                            )}
                                        </div>
                                        <div className="ml-6 max-w-md">
                                            <div className="text-2xl font-semibold mb-1">{step.title}</div>
                                            <div className="text-lg text-gray-700">{step.desc}</div>
                                        </div>
                                    </div>
                                ));
                            })()}
                        </div>
                    </div>
                </section>

            </main>
        </div>
    );
}

export default SamplePage;
